import { View, ViewType } from "@common/types/views/views";

export enum HistoryClassDetailsColumn {
    TIME = "time",
    CLASS_NAME = "className",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export interface HistoryClassDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{ id: HistoryClassDetailsColumn; options?: any }>;
}
